import {request} from "./request";


export function AdminGetLogs() {
  return request({
    url: 'logs/AdminGetLogs',
  })
}
